import React from 'react';
import { Provider } from 'react-redux';
import store from './redux/store';
import { BrowserRouter as Router } from 'react-router-dom';
import Views from './views';
import { Route, Switch } from 'react-router-dom';
import { ThemeSwitcherProvider } from 'react-css-theme-switcher';
import { THEME_CONFIG } from './configs/AppConfig';
import { ToastContainer } from 'react-toast'; 
import 'mapbox-gl/dist/mapbox-gl.css';

const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <ThemeSwitcherProvider themeMap={themes} defaultTheme={THEME_CONFIG.currentTheme} 
          insertionPoint={document.getElementById('styles-insertion-point')}>
          <Router
            getUserConfirmation={() => {
              /* Empty callback to block the default browser prompt */
            }}>
            <Switch>
              <Route path="/" component={Views} />
            </Switch>
          </Router>
        </ThemeSwitcherProvider>
      </Provider>
      <ToastContainer
        position="bottom-left"
        delay={5000}
      />
    </div>
  );
}


export default (App);